<script lang="ts">
	/**
	 * One grey shape in a page skeleton. Every skeleton below is built from these so the bars share
	 * one colour and one radius — gray-300/700, visible at every `bg-depth` level, as `Skeleton`'s.
	 *
	 * Sizes are passed as **whole Tailwind classes** (`h-4 w-1/2`), never assembled from parts: a
	 * class built at runtime is invisible to the JIT scanner and silently never ships.
	 */
	let className: string = 'h-3 w-full';
	export { className as class };
	/** A circle or a square tile rather than a bar. */
	export let round: 'full' | 'xl' = 'full';
</script>

<div class="{className} bg-gray-300 dark:bg-gray-700 {round === 'full' ? 'rounded-full' : 'rounded-xl'}" />
